import { createFileRoute } from "@tanstack/react-router";
import { LogoDesignServicePage } from "./services_.logo-design";

export const Route = createFileRoute("/services_/branding-creatives-and-logo-identity-services")({
  head: () => ({
    meta: [
      {
        title: "Logo & Brand Identity Services — KMWAdvertising",
      },
      {
        name: "description",
        content: "Creating Logos & Visual Identities That Become Business Assets.",
      },
    ],
  }),
  component: LogoDesignServicePage,
});
